import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse,
} from "./default-actions/paging-actions"

import {
    itemRequest,
    itemResponse,
    itemCachedResponse,
    itemErrorResponse,
    itemSaveRequest,
    itemSaveErrorResponse,
} from "./default-actions/entity-actions"

import {
    TOPIC_ITEM_REQUEST,
    TOPIC_ITEM_RESPONSE,
    TOPIC_ITEM_CACHED_RESPONSE,
    TOPIC_ITEM_ERROR_RESPONSE,
    TOPIC_ITEM_SAVE_REQUEST,
    TOPIC_ITEM_SAVE_RESPONSE,
    TOPIC_ITEM_SAVE_ERROR_RESPONSE,
    TOPIC_ITEM_SYNC_REQUEST,
    TOPIC_ITEM_SYNC_RESPONSE,
    TOPIC_ITEM_SYNC_ERROR_RESPONSE,
    TOPIC_LIST_REQUEST,
    TOPIC_LIST_RESPONSE,
    TOPIC_LIST_CACHED_RESPONSE,
    TOPIC_LIST_ERROR_RESPONSE,
    TOPIC_LIST_COUNT_REQUEST,
    TOPIC_LIST_COUNT_RESPONSE,
    TOPIC_LIST_COUNT_CACHED_RESPONSE,
    TOPIC_LIST_COUNT_ERROR_RESPONSE,
    TOPIC_FINGERPRINT_REQUEST,
    TOPIC_FINGERPRINT_RESPONSE,
    TOPIC_FINGERPRINT_CACHED_RESPONSE,
    TOPIC_FINGERPRINT_ERROR_RESPONSE,
    TOPIC_FINGERPRINT_PREVIEW_REQUEST,
    TOPIC_FINGERPRINT_PREVIEW_RESPONSE,
    TOPIC_FINGERPRINT_PREVIEW_ERROR_RESPONSE,
} from "./action-types"

// Entity Request/Response Actions
export const topicItemRequest = itemRequest(TOPIC_ITEM_REQUEST)
export const topicItemResponse = itemResponse(TOPIC_ITEM_RESPONSE)
export const topicItemErrorResponse = itemErrorResponse(
    TOPIC_ITEM_ERROR_RESPONSE
)
export const topicItemCachedResponse = itemCachedResponse(
    TOPIC_ITEM_CACHED_RESPONSE
)
export const topicItemSaveRequest = itemSaveRequest(TOPIC_ITEM_SAVE_REQUEST)
export const topicItemSaveResponse = itemResponse(TOPIC_ITEM_SAVE_RESPONSE)
export const topicItemSaveErrorResponse = itemSaveErrorResponse(
    TOPIC_ITEM_SAVE_ERROR_RESPONSE
)
export const topicItemSyncRequest = itemSaveRequest(TOPIC_ITEM_SYNC_REQUEST)
export const topicItemSyncResponse = itemResponse(TOPIC_ITEM_SYNC_RESPONSE)
export const topicItemSyncErrorResponse = itemSaveErrorResponse(
    TOPIC_ITEM_SYNC_ERROR_RESPONSE
)

// Topic Paging Actions
export const topicListRequest = listRequest(TOPIC_LIST_REQUEST)
export const topicListResponse = listResponse(TOPIC_LIST_RESPONSE)
export const topicListCachedResponse = listCachedResponse(
    TOPIC_LIST_CACHED_RESPONSE
)
export const topicListErrorResponse = listErrorResponse(
    TOPIC_LIST_ERROR_RESPONSE
)

// Topic List Count Actions
export const topicListCountRequest = listRequest(TOPIC_LIST_COUNT_REQUEST)
export const topicListCountResponse = listResponse(TOPIC_LIST_COUNT_RESPONSE)
export const topicListCountCachedResponse = listCachedResponse(
    TOPIC_LIST_COUNT_CACHED_RESPONSE
)
export const topicListCountErrorResponse = listErrorResponse(
    TOPIC_LIST_COUNT_ERROR_RESPONSE
)

// Topic Fingerprint Actions
export const topicFingerprintRequest = itemRequest(TOPIC_FINGERPRINT_REQUEST)
export const topicFingerprintResponse = itemResponse(TOPIC_FINGERPRINT_RESPONSE)
export const topicFingerprintErrorResponse = itemErrorResponse(
    TOPIC_FINGERPRINT_ERROR_RESPONSE
)
export const topicFingerprintCachedResponse = itemCachedResponse(
    TOPIC_FINGERPRINT_CACHED_RESPONSE
)
export const topicFingerprintPreviewRequest = (
    mappings,
    removedConcepts,
    topicName,
    callbackActionCreator
) => ({
    type: TOPIC_FINGERPRINT_PREVIEW_REQUEST,
    mappings,
    removedConcepts,
    topicName,
    callbackActionCreator,
})
export const topicFingerprintPreviewResponse = (
    data,
    callbackActionCreator
) => ({
    type: TOPIC_FINGERPRINT_PREVIEW_RESPONSE,
    data,
    callbackActionCreator,
})
export const topicFingerprintPreviewErrorResponse = (
    error,
    callbackActionCreator
) => ({
    type: TOPIC_FINGERPRINT_PREVIEW_ERROR_RESPONSE,
    error,
    callbackActionCreator,
})
